import { ListItem } from '../utility'
import { BaseEnumEx } from './base-enum-ex'
import { DataMap } from '@grapecity/wijmo.grid'

// NOTE: Make sure this stays in sync with the server-side enum
export enum MeetingPageType {
    TitlePage,
    Checkin,
    Metrics,
    Rocks,
    Headlines,
    Todos,
    Oppurtunities,
    Wrapup,
    NotesBox,
    ExternalPage,
    Whiteboard,
    Mixed,
}

export class MeetingPageTypeEx extends BaseEnumEx {
    public static toDisplay(item: MeetingPageType) {
        switch (item) {
            case MeetingPageType.TitlePage:
                return 'Title Page'
            case MeetingPageType.Checkin:
                return 'Check-in'
            case MeetingPageType.Metrics:
                return 'Metrics'
            case MeetingPageType.Rocks:
                return 'ROCKS - Quarterly & Annual'
            case MeetingPageType.Headlines:
                return 'HeadlinesWINS'
            case MeetingPageType.Todos:
                return 'To-Dos'
            case MeetingPageType.Oppurtunities:
                return 'Opportunities - IdentifyDiscussSovle Issues'
            case MeetingPageType.Wrapup:
                return 'Wrap-up'
            case MeetingPageType.NotesBox:
                return 'Notes Box'
            case MeetingPageType.ExternalPage:
                return 'External Page'
            case MeetingPageType.Whiteboard:
                return 'Whiteboard'
            case MeetingPageType.Mixed:
                return 'Mixed'
        }
    }

    public static toDataMap(): DataMap {
        return new DataMap(MeetingPageTypeEx.ToListItems(), 'value', 'display')
    }

    public static ToListItems(): ListItem<number>[] {
        return [
            new ListItem(MeetingPageType.TitlePage, MeetingPageTypeEx.toDisplay(MeetingPageType.TitlePage)),
            new ListItem(MeetingPageType.Checkin, MeetingPageTypeEx.toDisplay(MeetingPageType.Checkin)),
            new ListItem(MeetingPageType.Metrics, MeetingPageTypeEx.toDisplay(MeetingPageType.Metrics)),
            new ListItem(MeetingPageType.Rocks, MeetingPageTypeEx.toDisplay(MeetingPageType.Rocks)),
            new ListItem(MeetingPageType.Headlines, MeetingPageTypeEx.toDisplay(MeetingPageType.Headlines)),
            new ListItem(MeetingPageType.Todos, MeetingPageTypeEx.toDisplay(MeetingPageType.Todos)),
            new ListItem(MeetingPageType.Oppurtunities, MeetingPageTypeEx.toDisplay(MeetingPageType.Oppurtunities)),
            new ListItem(MeetingPageType.Wrapup, MeetingPageTypeEx.toDisplay(MeetingPageType.Wrapup)),
            new ListItem(MeetingPageType.NotesBox, MeetingPageTypeEx.toDisplay(MeetingPageType.NotesBox)),
            new ListItem(MeetingPageType.ExternalPage, MeetingPageTypeEx.toDisplay(MeetingPageType.ExternalPage)),
            new ListItem(MeetingPageType.Whiteboard, MeetingPageTypeEx.toDisplay(MeetingPageType.Whiteboard)),
            new ListItem(MeetingPageType.Mixed, MeetingPageTypeEx.toDisplay(MeetingPageType.Mixed)),
        ]
    }
}
